import { styled } from '@mui/material/styles';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';

export const StyledButton = styled(Button)(({ theme }) => ({
  float: 'right',
  paddingRight: theme.spacing(4),
  paddingLeft: theme.spacing(4),
}));

export const ButtonContainer = styled(Box)({
  flex: 1,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
});

export const chipContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  marginTop: theme.spacing(2),
}));

export const chipContainerList = styled(Box)({
  position: 'absolute',
  right: 10,
  top: 10,
  width: '100%',
  margin: 20,
  maxWidth: 250,
});

export const claim = styled(Chip)({
  background: 'rgba(78, 215, 225, 0.15)',
});

export const chip = styled(Chip)({
  flex: 1
})
